import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerRegistrationComponent } from './customer-registration.component';
import { RegistrationFormComponent } from './registration-form/registration-form.component';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { PreRegisterComponent } from './pre-register/pre-register.component';

const routes: Routes = [{
  path: '', component: CustomerRegistrationComponent, children: [
    {
      path: '', component: RegistrationFormComponent
    },
    {
      path: 'otp-verify', component: OtpVerifyComponent
    },
    {
      path: 'welcome', component: WelcomeComponent
    },
    {
      path: 'create-password', component: CreatePasswordComponent
    },
    {
      path: 'user-register', component: PreRegisterComponent
    }
  ]
},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule { }